import { dispatchEvent } from '../../services/analytics/events'
import { widgetState } from '../../store/customizations/index'
import { buildElement } from '../../utils/element'

const renderTopBar = (mainElement: HTMLElement) => {
  const topBarElement = getTopBarElement()
  mainElement.appendChild(topBarElement)
  return topBarElement
}
export const getTopBarElement = () => {
  const topBarElement = buildElement('div', 'yotpo-live-preview-bar', {})
  const topBarStyle = buildElement('style', 'yotpo-live-preview-bar-style', {})
  topBarStyle.innerHTML = getStyles()
  topBarElement.appendChild(topBarStyle)
  const contentContainerElement = buildElement('div', 'yotpo-live-preview-bar-content-container', {})
  const yotpoLogo = buildYotpoLogoElement()
  const textContainerElement = buildTextContainer()
  const closeButtonElement = buildCloseButtonElement()
  const ctaButtonElement = buildCtaButtonElement()
  contentContainerElement.appendChild(yotpoLogo)
  contentContainerElement.appendChild(textContainerElement)
  contentContainerElement.appendChild(closeButtonElement)
  contentContainerElement.appendChild(ctaButtonElement)
  topBarElement.appendChild(contentContainerElement)

  const fontStyle = buildElement('link', '', {
    href: 'https://fonts.googleapis.com/css?family=Inter:400&display=swap',
    rel: 'stylesheet'
  })
  document.head.appendChild(fontStyle)

  return topBarElement
}

export const renderLivePreview = (mainElement: HTMLElement): HTMLElement => {
  return renderTopBar(mainElement)
}

export const getStyles = (): string => {
  return `
  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar {
      box-sizing: border-box;
  }

  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar {
      position: fixed;
      top: 260px;
      left: 0;
      width: 245px;
      height: 315px;
      background: ${widgetState.customizations.livePreview.topBar.backgroundColor};
      opacity: ${widgetState.customizations.livePreview.topBar.backgroundOpacity};
      color: ${widgetState.customizations.livePreview.topBar.fontColor};
      line-height: 20px;
      font-family: Inter;
      z-index: 9999;
      padding: 20px;
  }

  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar .yotpo-live-preview-bar-content-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: left;
      height: 100%
  }

  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar .yotpo-live-preview-bar-content-container .yotpo-live-preview-bar-logo {
      max-width: 66px;
  }

  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar .yotpo-live-preview-bar-content-container .yotpo-live-preview-bar-text-container .yotpo-live-preview-bar-header-text {
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 14px;
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar .yotpo-live-preview-bar-content-container .yotpo-live-preview-bar-text-container .yotpo-live-preview-bar-help-text {
      font-size: 14px;
      line-height: 24px;
  }

  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar .yotpo-live-preview-bar-content-container .yotpo-live-preview-bar-close-button {
      background: ${widgetState.customizations.livePreview.topBar.closeButtonBackgroundColor};
      color: ${widgetState.customizations.livePreview.topBar.closeButtonTextColor};
      text-align: center;
      text-decoration: none;
      border-radius: 3px;
      padding: 8px 16px;
      font-family: Inter;
      font-weight: 600;
      font-size: 13px;
      line-height: 20px;
      cursor: pointer;
  }

    .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar .yotpo-live-preview-bar-content-container .yotpo-live-preview-bar-cta-text {
      color: ${widgetState.customizations.livePreview.topBar.fontColor};
      text-align: center;
      font-family: Inter;
      font-size: 14px;
      line-height: 20px;
  }

  .yotpo-widget-subscriptions-add-to-cart .yotpo-live-preview-bar .yotpo-live-preview-bar-content-container .yotpo-live-preview-bar-cta-trigger {
      text-decoration: underline;
  }

  ${getWidgetMarking()}`
}

function buildTextContainer (): HTMLElement {
  const textContainerElement = buildElement('div', 'yotpo-live-preview-bar-text-container', {})
  const headerTextElement = buildElement('div', 'yotpo-live-preview-bar-header-text', {})
  headerTextElement.innerText = widgetState.customizations.livePreview.topBar.headerText
  textContainerElement.appendChild(headerTextElement)
  const helpText = buildElement('div', 'yotpo-live-preview-bar-help-text', {})
  helpText.innerText = widgetState.customizations.livePreview.topBar.helpText
  textContainerElement.appendChild(helpText)

  return textContainerElement
}

function buildYotpoLogoElement () {
  return buildElement('img', 'yotpo-live-preview-bar-logo', {
    src: 'https://cdn-widget-assets.yotpo.com/SubscriptionsAddToCartWidget/assets/1.1.9/assets/images/yotpo-logo.png'
  })
}

function buildCtaButtonElement (): HTMLElement {
  const onClickLink = `https://subscriptions.yotpo.com/#/on-boarding/${widgetState.customizations.livePreview.topBar.ctaLinkPath}?open_chat=true`
  const ctaButtonWrapperElement = buildElement('span', 'yotpo-live-preview-bar-cta-text', {})
  ctaButtonWrapperElement.innerText = 'Need help? '
  const ctaButtonElement = buildElement('a', 'yotpo-live-preview-bar-cta-text yotpo-live-preview-bar-cta-trigger', {
    href: onClickLink,
    target: '_blank'
  })
  ctaButtonElement.innerText = widgetState.customizations.livePreview.topBar.ctaText
  ctaButtonElement.addEventListener('click', () => previewEvent(onClickLink))
  ctaButtonWrapperElement.appendChild(ctaButtonElement)
  return ctaButtonWrapperElement
}

function buildCloseButtonElement (): HTMLElement {
  const closeButtonElement = buildElement('button', 'yotpo-live-preview-bar-close-button', {})
  closeButtonElement.innerText = widgetState.customizations.livePreview.topBar.closeButtonText
  closeButtonElement.addEventListener('click', () => window.close())
  return closeButtonElement
}

const previewEvent = (link: string): void => {
  dispatchEvent({
    action: 'clicked_on',
    label: 'get_live_support',
    context: {
      cta_link: link
    }
  })
}

function getWidgetMarking (): string {
  const widgetMarkingStrategy = widgetState.customizations.livePreview.widgetMarkingStrategy
  if (widgetMarkingStrategy === 'blinking_border') {
    return `.yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plans-wrapper {
              outline: 3px solid transparent;
              animation: yotpo-blink 1s;
              animation-iteration-count: 5;
            }

            @keyframes yotpo-blink {
              50% {
                border-radius: 5px;
                outline-color:${widgetState.customizations.livePreview.topBar.backgroundColor};
              }
            }`
  }

  if (widgetMarkingStrategy === 'stable_border') {
    return `.yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plans-wrapper {
              border: 3px solid ${widgetState.customizations.livePreview.topBar.backgroundColor};
              border-radius: 5px;
            }`
  }
}
